<template>
  <v-layout>
    <div
      class="py-14 sm:pb-36"
    >
      <div class="container max-w-lg">
        <img
          src="/img/icons/svg/streamline-icon-task-checklist-check@48x48.svg"
          alt="Goals"
          class="w-20 mx-auto mb-5"
        >

        <h1 class="title-1 mb-0 text-center">
          My Goals
        </h1>

        <div class="flex justify-center mb-1">
          <select
            v-model="period"
            class="placeholder:text-primary-800 focus:border-0 focus:outline-none focus:shadow-none focus:ring-0 text-primary-800 bg-transparent border-0"
            @change="fetch"
          >
            <option value="1">
              Last month
            </option>
            <option value="6">
              Last 6 months
            </option>
            <option value="12">
              Last 12 months
            </option>
          </select>
        </div>

        <div class="flex mb-6">
          <button
            type="button"
            class="flex-1 py-3 font-semibold bg-transparent border-b-[3px]  outline-none appearance-none"
            :class="{'border-b-moss-500 text-moss-800': tab == 'milestones', 'text-black opacity-40 border-b-black border-opacity-10': tab != 'milestones'}"
            @click="tab = 'milestones'"
          >
            Milestones
          </button>
          <button
            type="button"
            class="flex-1 py-3 font-semibold bg-transparent border-b-[3px] outline-none  appearance-none"
            :class="{'border-b-moss-500 text-moss-800': tab == 'achievements', 'text-black opacity-40 border-b-black border-opacity-10': tab != 'achievements'}"
            @click="tab = 'achievements'"
          >
            Achievements
          </button>
        </div>

        <v-achievements-details
          v-show="tab == 'achievements'"
          class="duration-300"
          :class="{'opacity-50': loading}"
          :achievements="achievements"
        />
        <v-milestones-details
          v-show="tab == 'milestones'"
          class="duration-300"
          :class="{'opacity-50': loading}"
          :milestones="milestones"
        />
      </div>
    </div>
  </v-layout>
</template>
<script>
import achievementsDetails from "./includes/achievements-details.vue";
import milestonesDetails from "./includes/milestones-details.vue";
export default {
  name: "v-achivements",
  components: {
    "v-achievements-details": achievementsDetails,
    "v-milestones-details": milestonesDetails,
  },
  data() {
    return {
      achievements: {
        total_offset: 0,
        net_footprint: 0,
        number_of_planted_trees: 0,
      },
      milestones: {
        next_tree: 0,
        tree_offset: 10,
      },
      tab: "milestones",
      loading: false,
      period: "12",
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    fetch() {
      this.loading = true;
      this.$http.get(this.$laravel.route("api.users.goals"),{params:{period: this.period}})
        .then(
          (response) => {
            this.achievements = response.data.achievements;
            this.milestones = response.data.milestones;
          }
        )
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
